
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_11svs_9",
  "input": "awsui_input_2rhyz_11svs_13",
  "input-readonly": "awsui_input-readonly_2rhyz_11svs_62",
  "input-invalid": "awsui_input-invalid_2rhyz_11svs_105",
  "input-warning": "awsui_input-warning_2rhyz_11svs_108",
  "input-type-search": "awsui_input-type-search_2rhyz_11svs_111",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_11svs_121",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_11svs_124",
  "input-container": "awsui_input-container_2rhyz_11svs_128",
  "input-field": "awsui_input-field_2rhyz_11svs_133",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_11svs_157",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_11svs_174",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_11svs_182",
  "input-field-warning": "awsui_input-field-warning_2rhyz_11svs_195",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_11svs_208",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_11svs_208",
  "grouped": "awsui_grouped_2rhyz_11svs_223",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_11svs_229",
  "grouped-in-error": "awsui_grouped-in-error_2rhyz_11svs_236",
  "grouped-in-warning": "awsui_grouped-in-warning_2rhyz_11svs_241",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_11svs_256",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_11svs_280",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_11svs_307",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_11svs_334",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_11svs_358",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_11svs_385",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_11svs_385",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_11svs_415",
  "grouped-validation": "awsui_grouped-validation_2rhyz_11svs_425",
  "input-prefix": "awsui_input-prefix_2rhyz_11svs_430",
  "input-suffix": "awsui_input-suffix_2rhyz_11svs_431",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_11svs_445",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_11svs_454",
  "input-icon-start": "awsui_input-icon-start_2rhyz_11svs_480",
  "input-icon-end": "awsui_input-icon-end_2rhyz_11svs_487",
  "input-button-right": "awsui_input-button-right_2rhyz_11svs_493",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_11svs_497",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_11svs_500",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_11svs_504",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_11svs_507",
  "inline-label": "awsui_inline-label_2rhyz_11svs_497",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_11svs_532"
};
  